var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { useCallback, useEffect, useState } from 'react';
import { MessageActionsBox } from './MessageActionsBox';
import { isUserMuted } from '../Message/utils';
import { useChatContext } from '../../context/ChatContext';
import { useMessageContext } from '../../context/MessageContext';
export var MessageActions = function MessageActions(props) {
  var _a = props.customWrapperClass,
      customWrapperClass = _a === void 0 ? '' : _a,
      propGetMessageActions = props.getMessageActions,
      propHandleDelete = props.handleDelete,
      propHandleFlag = props.handleFlag,
      propHandleMute = props.handleMute,
      propHandlePin = props.handlePin,
      inline = props.inline,
      propMessage = props.message,
      messageWrapperRef = props.messageWrapperRef,
      mine = props.mine;
  var mutes = useChatContext().mutes;

  var _b = useMessageContext(),
      contextGetMessageActions = _b.getMessageActions,
      contextHandleDelete = _b.handleDelete,
      contextHandleFlag = _b.handleFlag,
      contextHandleMute = _b.handleMute,
      contextHandlePin = _b.handlePin,
      isMyMessage = _b.isMyMessage,
      contextMessage = _b.message,
      setEditingState = _b.setEditingState;

  var getMessageActions = propGetMessageActions || contextGetMessageActions;
  var handleDelete = propHandleDelete || contextHandleDelete;
  var handleFlag = propHandleFlag || contextHandleFlag;
  var handleMute = propHandleMute || contextHandleMute;
  var handlePin = propHandlePin || contextHandlePin;
  var message = propMessage || contextMessage;

  var _c = useState(false),
      actionsBoxOpen = _c[0],
      setActionsBoxOpen = _c[1];

  var isMuted = useCallback(function () {
    return isUserMuted(message, mutes);
  }, [message, mutes]);
  var hideOptions = useCallback(function () {
    return setActionsBoxOpen(false);
  }, []);
  var messageActions = getMessageActions();
  var messageDeletedAt = !!(message === null || message === void 0 ? void 0 : message.deleted_at);
  useEffect(function () {
    if (messageWrapperRef === null || messageWrapperRef === void 0 ? void 0 : messageWrapperRef.current) {
      messageWrapperRef.current.addEventListener('mouseleave', hideOptions);
    }
  }, [hideOptions, messageWrapperRef]);
  useEffect(function () {
    if (messageDeletedAt) {
      document.removeEventListener('click', hideOptions);
    }
  }, [hideOptions, messageDeletedAt]);
  useEffect(function () {
    if (actionsBoxOpen) {
      document.addEventListener('click', hideOptions);
    } else {
      document.removeEventListener('click', hideOptions);
    }

    return function () {
      return document.removeEventListener('click', hideOptions);
    };
  }, [actionsBoxOpen, hideOptions]);
  if (messageActions.length === 0) return null;
  return React.createElement(MessageActionsWrapper, {
    customWrapperClass: customWrapperClass,
    inline: inline,
    setActionsBoxOpen: setActionsBoxOpen
  }, React.createElement(MessageActionsBox, {
    getMessageActions: getMessageActions,
    handleDelete: handleDelete,
    handleEdit: setEditingState,
    handleFlag: handleFlag,
    handleMute: handleMute,
    handlePin: handlePin,
    isUserMuted: isMuted,
    mine: mine ? mine() : isMyMessage(),
    open: actionsBoxOpen
  }), React.createElement("svg", {
    height: '4',
    viewBox: '0 0 11 4',
    width: '11',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement("path", {
    d: 'M1.5 3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm4 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm4 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z',
    fillRule: 'nonzero'
  })));
};

var MessageActionsWrapper = function MessageActionsWrapper(props) {
  var children = props.children,
      customWrapperClass = props.customWrapperClass,
      inline = props.inline,
      setActionsBoxOpen = props.setActionsBoxOpen;
  var defaultWrapperClass = 'str-chat__message-simple__actions__action str-chat__message-simple__actions__action--options';
  var wrapperClass = customWrapperClass || defaultWrapperClass;

  var onClickOptionsAction = function onClickOptionsAction(event) {
    event.stopPropagation();
    setActionsBoxOpen(true);
  };

  var wrapperProps = {
    className: wrapperClass,
    'data-testid': 'message-actions',
    onClick: onClickOptionsAction
  };
  if (inline) return React.createElement("span", __assign({}, wrapperProps), children);
  return React.createElement("div", __assign({}, wrapperProps), children);
};